import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'
import type { AttachmentResponse } from '~/domains/attachments/types'

type SaveGeneratedResumePayload = {
  blob: Blob
  filename: string
}

export const useSaveGeneratedResumeMutation = (
  applicantId: number | undefined
) => {
  const queryClient = useQueryClient()

  return useMutation<
    AttachmentResponse,
    ApiResponseError,
    SaveGeneratedResumePayload
  >({
    mutationFn: ({ blob, filename }) => {
      if (!applicantId) throw new Error('applicantId is required')
      const formData = new FormData()
      formData.append(
        'file',
        new File([blob], filename, { type: 'application/pdf' })
      )

      return fetchApiWithToken<AttachmentResponse>({
        method: 'post',
        url: `/v1/applicants/${applicantId}/attachments?isGenerated=1`,
        data: formData
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['applicants', applicantId, 'attachments']
      })
    }
  })
}
